import React, { useEffect } from 'react';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0a0a0a] min-h-screen text-white pt-40 pb-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-16">
          <div className="w-full md:w-1/2 relative">
            <div className="border-2 border-[#d4af37] p-2 relative z-10 bg-[#0a0a0a]">
              <img 
                src="https://images.unsplash.com/photo-1550503564-90b94098939c?auto=format&fit=crop&q=80&w=1000" 
                alt="Prime Eats Crew" 
                className="w-full grayscale h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-white/10 -z-10"></div>
          </div>

          <div className="w-full md:w-1/2">
            <h1 className="font-['Bebas_Neue'] text-8xl mb-6 italic leading-none">
              THE <span className="text-[#d4af37]">PRIME</span> EATS STORY (TBA)
            </h1>
            <p className="text-gray-400 text-xl leading-relaxed mb-6 font-light italic">
              "We don't just cook burgers. We tune them for performance."
            </p>
            <div className="space-y-4 text-gray-500 text-lg leading-relaxed mb-10">
              <p>Founded in 2018 in Westland, MI, Prime Eats was built on the idea that food should be high-octane. We use 100% Zabiha beef.</p>
              <p>Our mission is simple: provide the neighborhood with a premium Prime Eats for world-class smash burgers, wraps and fries, served with speed and precision.</p>
            </div>
            
            <div className="grid grid-cols-2 gap-8 border-t border-white/10 pt-8">
              <div>
                <div className="text-[#d4af37] font-['Bebas_Neue'] text-4xl">100%</div>
                <div className="text-xs uppercase tracking-widest text-gray-500 font-bold">Zabiha Halaal</div>
              </div>
              <div>
                <div className="text-[#d4af37] font-['Bebas_Neue'] text-4xl">WESTLAND</div>
                <div className="text-xs uppercase tracking-widest text-gray-500 font-bold">Home Track</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;